// @ts-nocheck
const DEV = import.meta.env?.DEV ?? false;

const send = DEV
    ? (tag, data) => {
        const params = new URLSearchParams({cl: 'm7-checkout-dpc', fnc: 'frontendLog'});
        fetch(`/index.php?${params}`, {
            method: 'POST',
            credentials: 'include',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({tag, data}),
        }).catch(() => {});
    }
    : () => {};

export const devLog = DEV
    ? (tag, ...args) => {
        console.log(`[Checkout:${tag}]`, ...args);
        send(tag, args.length === 1 ? args[0] : args);
    }
    : () => {};
